import React, { FC } from "react";
import { Modal, Table } from "antd";
import { Link } from "react-router-dom";
import { MaterialItem } from "shared/api";

interface MaterialItemsModalProps {
  visible: boolean;
  onClose: () => void;
  materialItems: MaterialItem[];
}

export const MaterialItemsModal: FC<MaterialItemsModalProps> = ({
  visible,
  onClose,
  materialItems,
}) => {
  const columns = [
    {
      title: "Serial Numbers",
      dataIndex: "serial_number",
      key: "serial_number",
      render: (serial_number: string, record: MaterialItem) => {
        if (!serial_number) return "N/A";

        return (
          <Link
            to={`/material-management/article/${record.id}`}
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {serial_number}
          </Link>
        );
      },
    },
  ];

  return (
    <Modal
      title="Material Items"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
    >
      <Table
        columns={columns}
        dataSource={materialItems}
        pagination={{
          pageSize: 10,
          showSizeChanger: false,
        }}
        rowKey="id"
        size="small"
      />
    </Modal>
  );
};
